import { useTranslation } from 'react-i18next';
import { IJxtFloorInfos } from './types';
import JxtResourceIcon from '../JxtResourceIcon';
import { JxtResourcesTypeEnum } from '@jooxter/utils';

const JxtFloorInfos = ({ name, locationName, floor, pictures }: IJxtFloorInfos) => {
  const { t } = useTranslation();

  return (
    <div className="flex gap-3">
      {pictures ? (
        <img
          src={pictures}
          className="rounded-xl size-[72px] object-cover shrink-0"
          alt={`Picture of ${locationName}`}
        />
      ) : (
        <JxtResourceIcon type={JxtResourcesTypeEnum.OTHER} />
      )}
      <div className="flex flex-col justify-center truncate">
        <p className="text-title-m text-neutral-140 font-medium truncate">{name}</p>
        {locationName && (
          <p className="text-body-s text-neutral-100">
            {locationName}
            {(!!floor || floor === 0) && ' - ' + t('resource-short-card-floor-number', { floorNumber: floor })}
          </p>
        )}
      </div>
    </div>
  );
};

export default JxtFloorInfos;
